import { useEffect, useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, MenuProps, message, Popover, Select, Tooltip } from 'antd';
import { Button, Space, Row, Col, Modal, Input, Spin } from 'antd';
import dayjs from 'dayjs';
import closeIcon from '@/assets/images/Icons_Cross.png';
import { useAppSelector } from '@/store/hooks';
import debounce from 'lodash.debounce';
import api from '@/api/payment';
import Pagination from '@/components/pagination';
import publicMethod, { disabledDate } from '@/utils/publicMethod';
import useDownLoadCSV from '@/hook/useDownLoadCSV';
import { calendarIcon, searchIcon } from '@/constants/static';
const Payout = props => {
    const { RangePicker } = DatePicker;
    const [loading, setLoading] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [listParams, setListParams] = useState({
        pageNum: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        keyword: '',
        taskState: 'active',
    });
    const [metaData, setMetaData] = useState({
        faastaaFees: '0.00',
        taskerFees: '300.00',
        totalEarnings: '300.00',
        totalHistoryPayout: '300.00',
        totalStripeFees: '0.00',
        totalUpcomingPayout: '0.00',
    });
    const [tableData, setTableData] = useState<any[]>([]);
    const inputChange = e => {
        setListParams(state => ({ ...state, keyword: e.target.value, pageNum: 1 }));
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => getPayList(nextValue), 1500),
        []
    );
    async function getPayList(params) {
        setLoading(true);
        const apiParams: any = {
            pageNum: params.pageNum,
            pageSize: 10,
            taskState: params.taskState,
        };
        if (params.startDate && params.endDate) {
            apiParams.startDate = params.startDate;
            apiParams.endDate = params.endDate;
        }
        if (params.keyword) {
            apiParams.keyword = params.keyword;
        }
        try {
            const res = await api.getPaymentList(apiParams);
            setTotalRecord(Number(res.data.total));
            setMetaData({ ...metaData, ...res.data.metaData });
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    taskWorkTime: item.workStartTime
                        ? window.utils.formatWorkPeriod(
                              //   item.workStartDate,
                              item.workStartTime,
                              //   item.workEndDate,
                              item.workEndTime
                          )
                        : '-',
                });
            });
            setTableData(list);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    }
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
        getPayList({ ...listParams, pageNum: prop });
    };
    useEffect(() => {
        getPayList(listParams);
    }, []);
    const dateOnChange = date => {
        getPayList({
            ...listParams,
            pageNum: 1,
            startDate: date ? dayjs(date[0]).format('YYYY-MM-DD') : '',
            endDate: date ? dayjs(date[1]).format('YYYY-MM-DD') : '',
        });
        setListParams({
            ...listParams,
            pageNum: 1,
            startDate: date ? dayjs(date[0]).format('YYYY-MM-DD') : '',
            endDate: date ? dayjs(date[1]).format('YYYY-MM-DD') : '',
        });
    };
    const [tableTab, setTableTab] = useState(1);

    const totalNumberText = useMemo(() => {
        const list = ['Upcoming', 'History', 'Cancelled'];
        return `Total number of ${list[tableTab - 1]} Task`;
    }, [tableTab]);
    const exportFileName = useMemo(() => {
        const { startDate, endDate } = listParams;
        if (!startDate || !endDate) {
            return 'Payout data (All).csv';
        } else {
            return `Payout data (${dayjs(startDate).format('DD:MM:YYYY')} - ${dayjs(endDate).format(
                'DD:MM:YYYY'
            )}).csv`;
        }
    }, [listParams]);
    const { downloadCSV } = useDownLoadCSV(exportFileName);
    const handleExportCSV = async () => {
        const res = await api.getPaymentList({ ...listParams, pageNum: 1, pageSize: -1 });
        const data = res.data.records.map(item => {
            const {
                taskTitle,
                customer,
                tasker,
                applicationFeeAmount,
                actualRemunerationAmount,
                actualStripeTax,
                workStartTime,
            } = item;
            return {
                Task: taskTitle,
                Customer: customer.fullName,
                Tasker: tasker?.fullName || '-',
                'Task Value': `$${actualRemunerationAmount || '0'}`,
                'Faastaa Fees': `$${applicationFeeAmount || '0'}`,
                'Payment Fees': `$${actualStripeTax || '0'}`,
                'Task Date': workStartTime
                    ? window.utils.formatWorkPeriod(item.workStartTime, item.workEndTime).replaceAll(',', '-')
                    : '-',
            };
        });
        data.unshift({
            Task: 'Task',
            Customer: 'Customer',
            Tasker: 'Tasker',
            'Task Value': 'Task Value',
            'Faastaa Fees': 'Faastaa Fees',
            'Payment Fees': 'Payment Fees',
            'Task Date': 'Task Date',
        });
        if (tableTab === 3) {
            data.forEach(i => {
                delete i['Task Date'];
            });
        }
        downloadCSV(data);
    };
    return (
        <>
            <div className="page-main account">
                <div className="page-title">Payout</div>
                <div className="select-bar">
                    <div className="select-bar-left">
                        <RangePicker
                            className="search-input"
                            placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                            suffixIcon={calendarIcon}
                            separator={'-'}
                            format={'DD/MM/YYYY'}
                            disabledDate={disabledDate}
                            onChange={dateOnChange}
                        />
                        <Input
                            className="search-input"
                            placeholder="Search by task"
                            onChange={inputChange}
                            prefix={searchIcon}
                        />
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        disabled={!totalRecord}
                        style={{
                            height: 46,
                            width: 128,
                            borderRadius: 8,
                            justifySelf: 'flex-end',
                        }}
                        onClick={handleExportCSV}
                    >
                        Export
                    </Button>
                </div>

                {loading ? (
                    <div className="data_loading flex-center">
                        <Spin />
                    </div>
                ) : (
                    <>
                        <div className="page-total">
                            <div className="more-total bold-border">
                                <div className="total-item-left">
                                    <div className="total-label">Total Faastaa Revenue</div>
                                    <div className="total-num">
                                        $
                                        {metaData.totalEarnings
                                            ? publicMethod.formatPrice(metaData.totalEarnings)
                                            : '0.00'}
                                    </div>
                                </div>
                                <div className="split-line"></div>
                                <div className="total-item-flex">
                                    <div className="more-item">
                                        <div className="total-label">Total Tasker Fees 11.9%</div>
                                        <div className="total-num">
                                            $
                                            {metaData.taskerFees
                                                ? publicMethod.formatPrice(metaData.taskerFees)
                                                : '0.00'}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="total-label">Customer Fees 10%</div>
                                        <div className="total-num">
                                            $
                                            {metaData.faastaaFees
                                                ? publicMethod.formatPrice(metaData.faastaaFees)
                                                : '0.00'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="total-item total-item-c bold-border">
                                Total payment fees
                                <span>
                                    $
                                    {metaData.totalStripeFees
                                        ? publicMethod.formatPrice(metaData.totalStripeFees)
                                        : '0.00'}
                                </span>
                            </div>
                            {tableTab !== 3 && (
                                <div className="total-item total-item-c">
                                    Total {tableTab === 1 ? 'Upcoming Amount' : 'History Payout'}
                                    <span>
                                        $
                                        {metaData.totalUpcomingPayout
                                            ? publicMethod.formatPrice(metaData.totalUpcomingPayout)
                                            : '0.00'}
                                    </span>
                                </div>
                            )}
                            <div className="total-item total-item-c">
                                {totalNumberText}
                                <span>{totalRecord}</span>
                            </div>
                        </div>

                        <div className="table">
                            <div className="tabs-table" style={{ margin: '24px 0' }}>
                                <div
                                    className={
                                        tableTab === 1 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        setTableTab(1);
                                        setListParams({ ...listParams, pageNum: 1, taskState: 'active' });
                                        getPayList({ ...listParams, pageNum: 1, taskState: 'active' });
                                    }}
                                >
                                    Tasks in progress
                                </div>
                                <div
                                    className={
                                        tableTab === 2 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        setTableTab(2);
                                        setListParams({ ...listParams, pageNum: 1, taskState: 'completed' });
                                        getPayList({ ...listParams, pageNum: 1, taskState: 'completed' });
                                    }}
                                >
                                    History payout
                                </div>
                                <div
                                    className={
                                        tableTab === 3 ? 'tabs-table-item tabs-table-item-active' : 'tabs-table-item'
                                    }
                                    onClick={() => {
                                        setTableTab(3);
                                        setListParams({ ...listParams, pageNum: 1, taskState: 'cancelled' });
                                        getPayList({ ...listParams, pageNum: 1, taskState: 'cancelled' });
                                    }}
                                >
                                    Other payout
                                </div>
                                <Tooltip
                                    color="rgba(26,30,31,0.9)"
                                    placement="left"
                                    overlayInnerStyle={{
                                        padding: 16,
                                        borderRadius: 12,
                                    }}
                                    title={
                                        <div className="payout-tips">
                                            <div className="payout-tip">
                                                <span>Upcoming payout: </span> The amount of successfully matched and
                                                unfinished tasks (including Faastaa fees)
                                            </div>
                                            <div className="payout-tip">
                                                <span>History payout: </span>
                                                The amount of tasks completed and successfully paid (including Faastaa
                                                fees)
                                            </div>
                                            <div className="payout-tip">
                                                <div>
                                                    <span>Other payout: </span>Cancellation fees for canceled tasks.
                                                </div>
                                                <div>
                                                    ps. The list data in this section are for display only, and the
                                                    final calculation may be different.
                                                </div>
                                            </div>
                                        </div>
                                    }
                                >
                                    <img
                                        style={{ width: 24, height: 24, position: 'absolute', right: 24 }}
                                        src={require('@/assets/images/tip-trigger.png')}
                                        alt=""
                                    />
                                </Tooltip>
                            </div>

                            {tableData.length ? (
                                <>
                                    <div className="table-th">
                                        <Row>
                                            <Col span={4}>Task</Col>
                                            <Col span={4}>Customer</Col>
                                            <Col span={3}>Tasker</Col>
                                            {tableTab === 3 ? <Col span={3}>Cancelled By</Col> : ''}
                                            <Col span={3}>Task Value</Col>
                                            <Col span={3}>Faastaa Fees</Col>
                                            <Col span={3}>Payment Fees</Col>
                                            {tableTab !== 3 ? <Col span={4}>Task Date</Col> : ''}
                                        </Row>
                                    </div>
                                    {tableData.map((item, index) => (
                                        <Row className="table-tr" key={`payout-item-${index}`}>
                                            <Col span={4}>
                                                <div>{item.taskTitle}</div>
                                                {(tableTab === 2 && !item.paidToTaskerTime) ||
                                                (tableTab === 3 &&
                                                    item.canceledBy === 'tasker' &&
                                                    !item.paidToFaastaaWithCanceledTask) ? (
                                                    <div className="Pending-pay">Pending</div>
                                                ) : (
                                                    ''
                                                )}
                                            </Col>
                                            <Col span={4}>{item.customer ? item.customer.fullName : '-'}</Col>
                                            <Col span={3}>{item.tasker ? item.tasker.fullName : '-'}</Col>
                                            {tableTab === 3 ? (
                                                <Col span={3}>
                                                    <span
                                                        style={{
                                                            color: item.canceledBy === 'tasker' ? '#40C4FF' : '#7C4DFF',
                                                        }}
                                                    >
                                                        {item.canceledBy === 'tasker' ? 'Tasker' : 'Customer'}
                                                    </span>
                                                </Col>
                                            ) : (
                                                ''
                                            )}
                                            <Col span={3}>
                                                $
                                                {item.actualRemunerationAmount
                                                    ? publicMethod.formatPrice(item.actualRemunerationAmount)
                                                    : '0.00'}
                                            </Col>
                                            <Col span={3}>
                                                $
                                                {item.applicationFeeAmount
                                                    ? publicMethod.formatPrice(item.applicationFeeAmount)
                                                    : '0.00'}
                                            </Col>
                                            <Col span={3}>
                                                $
                                                {item.actualStripeTax
                                                    ? publicMethod.formatPrice(item.actualStripeTax)
                                                    : '0.00'}
                                            </Col>
                                            {tableTab !== 3 ? <Col span={4}>{item.taskWorkTime}</Col> : ''}
                                        </Row>
                                    ))}
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Payout;
